module.exports = __webpack_public_path__ + "zoom_out-v1-4067ef4d.svg";